/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { SelectHTMLAttributes, useEffect } from 'react';
import { Controller, useFormContext, useFormState } from 'react-hook-form';
import { IEpSelectOptionsListData } from '../../../../interfaces';
import { EpSelect } from '../../../EpSelect';
import { EpErrorMessage } from '../EpErrorMessage';

interface IEpStepSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  data: IEpSelectOptionsListData[];
  disabled?: boolean;
  errorMessage: string;
  registerId: string;
  visible?: boolean;
  description?: string;
  required?: boolean;
  customLabelValue?: any;
  selectOnChange?: (arg?: unknown) => void;
}

export const EpStepSelect = ({
  data,
  disabled = false,
  errorMessage,
  registerId,
  visible = true,
  description,
  required = true,
  customLabelValue = ['name', 'id'],
  selectOnChange,
  ...props
}: IEpStepSelectProps) => {
  const { control, setValue, getValues } = useFormContext();
  const { errors } = useFormState({
    control,
  });
  const takeDataLength = data?.length;
  const takeDisabledSelect = takeDataLength === 0;
  const takeSelectedSelect = takeDataLength === 1;

  const getSelectdText = (value: string) => {
    return data.filter((item) => {
      if (
        item.id?.toString() === value ||
        item.answerId?.toString() === value
      ) {
        if (item.answerDescription) item.name = item.answerDescription;
        return item;
      }
    });
  };

  useEffect(() => {
    if (takeSelectedSelect && data[0].id && data[0].name) {
      if (customLabelValue[0] === 'label') {
        // se o objeto data usa label/ value ao invés de id/name
        setValue(`${registerId}.inputValue`, data[0].value);
        setValue(`${registerId}.inputLabel`, data[0].label);
      } else {
        setValue(`${registerId}.inputValue`, data[0].id.toString());
        setValue(`${registerId}.inputLabel`, data[0].name);
      }
    }
  }, [takeSelectedSelect, setValue, registerId, data, customLabelValue]);

  let registerIdIndex = '';
  let registerIdIndexGroup = '';
  if (registerId.includes('questions')) {
    registerIdIndex = registerId.slice(
      registerId.indexOf('.') + 1,
      registerId.length,
    );
    if (registerIdIndex.includes('.')) {
      registerIdIndexGroup = registerIdIndex.slice(
        registerIdIndex.indexOf('.') + 1,
        registerIdIndex.length,
      );
      registerIdIndex = registerIdIndex.slice(0, registerIdIndex.indexOf('.'));
    }
  }

  let selectWithError = false as any;
  const newErrors: any = errors;

  if (registerIdIndex !== '' && registerIdIndexGroup !== '') {
    selectWithError =
      newErrors &&
      newErrors.questions &&
      newErrors.questions[registerIdIndex] &&
      !!newErrors.questions[registerIdIndex][registerIdIndexGroup];
  }

  if (registerIdIndex !== '' && registerIdIndexGroup === '') {
    selectWithError =
      newErrors &&
      newErrors.questions &&
      !!newErrors.questions[registerIdIndex];
  }

  if (registerIdIndex === '' && registerIdIndexGroup === '') {
    selectWithError = newErrors && !!newErrors[registerId];
  }

  if (description) setValue(`${registerId}.description`, description);

  if (!visible) null;

  return (
    <>
      {data && (
        <Controller
          name={`${registerId}.inputValue` as const}
          control={control}
          rules={{
            onChange: (e) => {
              setValue(
                `${registerId}.inputLabel`,
                getSelectdText(e.target.value)[0]?.name,
              );
              selectOnChange && selectOnChange(e);
            },
            required: { value: required, message: errorMessage },
          }}
          render={({ field }) => {
            return (
              <EpSelect
                selectId={registerId}
                selectName={registerId}
                selectSize={'md'}
                selectType={'single'}
                selectPlaceholderText={'Placeholder'}
                selectWithClearFieldButton={false}
                customLabelValue={customLabelValue}
                selectIsDisabled={disabled || takeDisabledSelect}
                onChange={field.onChange}
                onBlur={field.onBlur}
                value={field.value}
                name={field.name}
                selectWithError={selectWithError}
                //inputRef={field.ref}
                translations={{
                  loading: 'Loading...',
                  noResultsWereFound: 'No results were found',
                  thereAreNoOptionsToSelect: 'There are no options to select',
                  itIsAllowedToSelectOnlyNValues:
                    'Only {0} value(s) can be selected',
                  removeSelectedItem: 'Remove selected item',
                }}
                optionsData={data}
                itemSelected={getValues(`${registerId}.inputValue`)}
                {...props}
              />
            );
          }}
        />
      )}

      <EpErrorMessage inputName={`${registerId}.inputValue`} />
    </>
  );
};
